import React from 'react';
import {
    ControllerRenderProps,
    Path,
    PathValue,
    UseFormTrigger,
} from 'react-hook-form';

/**
 * Класс используется для генерации обработчиков событий для элемента Input обернутый в Controller
 */
export class InputFieldEventHandler<TFieldValues> {
    /**
     * Функция триггера валидации поля формы
     * @private
     */
    private readonly _validate: UseFormTrigger<TFieldValues>;

    /**
     * @param trigger Функция триггера валидации поля формы
     */
    constructor(trigger: UseFormTrigger<TFieldValues>) {
        this._validate = trigger;
    }

    /**
     * Возвращает необходимые для корректной работы валидации обработчики событий Input
     * @param field Обьект поля из Controller
     * @param fieldName Имя поля в форме для валидации (имя в хранилище)
     * @param setField Функция, устанавливающая значение в хранилище. Внимание: функция из стора должна быть привязана к контексту стора
     * @param validateOnChange (optional) (default: true) Указывает, вызывать ли валидацию поля на каждом событии onChange
     */
    getEventHandlers(
        field: ControllerRenderProps<TFieldValues, any>,
        fieldName: string,
        setField: (value: string) => void,
        validateOnChange: boolean = true,
    ) {
        const validate = this._validate;

        return {
            onBlur: (event: React.FocusEvent<HTMLInputElement>) => {
                field.onChange(event);
                field.onBlur();

                setField(event.target.value);
            },
            onClear: (event: React.MouseEvent<HTMLButtonElement>) => {
                field.onChange(
                    event.currentTarget.value as PathValue<
                        TFieldValues,
                        Path<TFieldValues>
                    >,
                );
                validate(fieldName as Path<TFieldValues>);

                setField(event.currentTarget.value);
            },
            onChange: (
                event: React.ChangeEvent<HTMLInputElement>,
                payload?: { value: string },
                forceValidate?: boolean,
            ) => {
                field.onChange(event);

                if (validateOnChange || forceValidate) {
                    validate(fieldName as Path<TFieldValues>);
                }

                setField(event.target.value);
            },
        };
    }
}
